import { render, staticRenderFns } from "./expeditors.vue?vue&type=template&id=73f54c33&scoped=true&"
import script from "./expeditors.vue?vue&type=script&lang=js&"
export * from "./expeditors.vue?vue&type=script&lang=js&"
import style0 from "./expeditors.vue?vue&type=style&index=0&id=73f54c33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f54c33",
  null
  
)

export default component.exports